import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3e38b8d9&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "../common.css?vue&type=style&index=0&id=3e38b8d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e38b8d9",
  null
  
)

export default component.exports